var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.29793 3.53805L5.98187 0.74082C6.12435 0.51091 6.37047 0.37041 6.64249 0.37041H9.40155C9.46632 0.37041 9.53109 0.37041 9.59585 0.395955L12.8273 1.24812C12.9008 1.26751 12.976 1.27976 13.0519 1.2847L13.7055 1.32726C14.0333 1.34861 14.3109 1.0885 14.3109 0.760029V0.760029C14.3109 0.446089 14.5654 0.191591 14.8793 0.191591H17.4484C17.8117 0.191591 18.1062 0.486097 18.1062 0.849388V1.28617C18.1062 1.40823 18.0073 1.50718 17.8852 1.50718V1.50718C17.7588 1.50718 17.6581 1.61301 17.6645 1.73925L17.6975 2.39799C17.7022 2.49317 17.723 2.58686 17.7589 2.67514L18.7539 5.12187C18.7927 5.21128 18.8057 5.30069 18.8057 5.40287V23.0676C18.8057 23.4891 18.456 23.8212 18.0415 23.8212H5.03627C4.56995 23.8212 4.1943 23.4508 4.1943 22.991V3.92123C4.1943 3.78073 4.23316 3.65301 4.29793 3.53805Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1879 12H6.81208C6.36358 12 6 12.3694 6 12.825V19.175C6 19.6306 6.36358 20 6.81208 20H16.1879C16.6364 20 17 19.6306 17 19.175V12.825C17 12.3694 16.6364 12 16.1879 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98887 3.97819C5.99282 3.9743 5.99621 3.96988 5.99895 3.96507L7.05699 2.1075C7.21243 1.83928 7.48446 1.686 7.79534 1.686H9.14517C9.22873 1.686 9.31128 1.70426 9.38704 1.7395V1.7395C9.69358 1.88208 9.81091 2.25752 9.64011 2.54927L7.6728 5.90977C7.49998 6.20497 7.18357 6.38638 6.84151 6.38638V6.38638C6.30951 6.38638 5.87824 5.95511 5.87824 5.42311V4.39383C5.87824 4.25655 5.91534 4.11927 5.97745 3.9939C5.98035 3.98806 5.98423 3.98276 5.98887 3.97819V3.97819Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJug);
export default __webpack_public_path__ + "static/media/Jug.b6b83da93deeea98b466c25cc158c0e1.svg";
export { ForwardRef as ReactComponent };